import { lazy } from 'react'

export const PrivacyPolicy = lazy(() => import('./v1/PrivacyPolicy'))
